<template>
  <d-card :class="['card-small d-inline-flex', { 'show': show }]" :style="{ 'top': `${top}px`, 'left': `${left}px` }">
    <d-card-body class="px-2 py-0">
      <d-button-group>
        <d-button @click="answerOption" theme="success" title="Resposta"><i class="fas fa-exclamation-circle"></i></d-button>
        <d-button @click="questionOption" :disabled="!cell.answer.id" theme="primary" title="Pergunta"><i class="fas fa-question-circle"></i></d-button>
        <d-button @click="groupOption" :disabled="cell.type !== 'col'" theme="info" title="Mesclar"><i class="far fa-object-group"></i></d-button>
        <d-button @click="ungroupOption" theme="light" title="Dividir"><i class="far fa-object-ungroup"></i></d-button>
        <d-button @click="arrowOption" theme="secondary" title="Setas"><i class="fas fa-expand-arrows-alt"></i></d-button>
        <d-button @click="cleanCell" theme="danger" title="Apagar celular"><i class="fas fa-trash"></i></d-button>
      </d-button-group>
    </d-card-body>
  </d-card>
</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import {
  CELL,
  CELL_SIZE,
  _PUZZLE_SET_CELL_,
  _PUZZLE_SET_ANSWER_,
  _PUZZLE_ARROW_OPTION_,
  _PUZZLE_SELECTED_CELL_,
  _PUZZLE_ANSWER_OPTION_,
  _PUZZLE_UNGROUP_OPTION_,
  _PUZZLE_CLOSE_ALL_MODAL_,
  _PUZZLE_QUESTION_OPTION_,
  _PUZZLE_PRE_GROUP_OPTION_,
} from '../PuzzleModel';

export default {
  name: 'puzzle-select-option-modal',
  data() {
    return {
      top: 0,
      cell: cloneDeep(CELL),
      left: 0,
      show: false,
    };
  },
  computed: {
    puzzle() {
      const { puzzle } = this.$store.state.puzzle;
      return puzzle;
    },
  },
  methods: {
    ...mapActions([
      'setPuzzleCell',
    ]),
    answerOption() {
      // this.closeAll();
      Events.$emit(_PUZZLE_ANSWER_OPTION_, this.cell);
    },
    questionOption() {
      this.closeAll();
      Events.$emit(_PUZZLE_QUESTION_OPTION_, this.cell);
    },
    validCells() {
      const { puzzleCell } = this.$store.state.puzzle;
      if (puzzleCell === null) {
        return true;
      }
      if (this.cell.positionx === puzzleCell.positionx &&
        this.cell.positiony === puzzleCell.positiony
      ) {
        return false;
      }
      return true;
    },
    groupOption() {
      this.closeAll();
      if (this.validCells()) {
        this.show = false;
        this.cell.updated = true;
        Events.$emit(_PUZZLE_PRE_GROUP_OPTION_, this.cell);
        return this.setPuzzleCell(this.cell);
      }
      Events.$emit(_PUZZLE_SELECTED_CELL_, this.cell);
      this.cell.active = false;
      return this.setPuzzleCell(cloneDeep(CELL));
    },
    ungroupOption() {
      this.closeAll();
      Events.$emit(_PUZZLE_UNGROUP_OPTION_, this.cell);
    },
    arrowOption() {
      this.closeAll();
      Events.$emit(_PUZZLE_ARROW_OPTION_, this.cell);
    },
    closeAll() {
      Events.$emit(_PUZZLE_CLOSE_ALL_MODAL_);
    },
    changeCellHide(nextPosition = 1) {
      const { table } = this.$store.state.puzzle.puzzle;
      const index = table.findIndex(cell => cell.positiony === this.cell.positiony && cell.positionx === this.cell.positionx);
      if (index >= 0) {
        if (table[index + nextPosition].hide) {
          table[index + nextPosition].updated = true;
          table[index + nextPosition].hide = false;
        }
      }
    },
    cleanParentCell(cell) {
      const [positionX] = cell.positionx.split('_');
      const [positionY] = cell.positiony.split('_');
      const index = (parseInt(positionY, Number) * parseInt(this.puzzle.columns, Number)) + parseInt(positionX, Number);
      this.cell = this.puzzle.table[index];
    },
    extractRowPosition(positiony) {
      return positiony.toString().split('_')[0];
    },
    cleanCell() {
      if (this.cell.answer.answer) {
        this.cell.answer.answer = this.cell.answer.answer.replace(/./g, ' ');
        Events.$emit(_PUZZLE_SET_ANSWER_, this.cell);
      }
      if (this.cell.type === 'colspan') {
        this.changeCellHide(1);
      }
      if (this.cell.type === 'rowspan') {
        const { columns } = this.$store.state.puzzle.puzzle;
        this.changeCellHide(columns);
      }
      if (this.cell.parent_id) {
        this.cleanParentCell(this.cell);
      }
      this.cell = {
        ...cloneDeep(CELL),
        ...{
          id: this.cell.id,
          positionx: this.cell.positionx,
          positiony: this.extractRowPosition(this.cell.positiony),
          parent_id: this.cell.parent_id,
          isQuestion: true,
          settings: {
            bold: true,
            font_size: 9,
            background: null
          },
          updated: true,
        },
      };
      Events.$emit(_PUZZLE_SET_CELL_, this.cell);
    },
  },
  destroyed() {
    Events.$off(_PUZZLE_SELECTED_CELL_);
  },
  mounted() {
    Events.$on(_PUZZLE_SELECTED_CELL_, cell => {
      this.cell = cell;
      this.show = cell.active;
      let { positiony } = cell;
      if (Number.isNaN(Number(cell.positiony))) {
        const positions = cell.positiony.split('_');
        [positiony] = positions;
      }
      this.top = (positiony * CELL_SIZE) + 77;
      this.left = ((cell.positionx * CELL_SIZE) + (CELL_SIZE / 2)) - 139;
    });
  },
};
</script>

<style lang="scss" scoped>
  .card-small {
    visibility: hidden;
    background-color: #d7d7d7;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1199;
    transition: all .5 ease-in;
    &:before {
      content: "";
      position: absolute;
      bottom: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: transparent transparent #d7d7d7 transparent;
    }
    &.show {
      visibility: visible;
      transition: all .5 ease-in;
    }
  }
</style>
